import { DialogRefundConfirmComponent } from './../dialog-refund-confirm/dialog-refund-confirm.component';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RefundsService } from 'src/app/services/refunds.service';

@Component({
  selector: 'app-dialog-refund-order',
  templateUrl: './dialog-refund-order.component.html',
  styleUrls: ['./dialog-refund-order.component.scss']
})
export class DialogRefundOrderComponent {

  bookingsOrder = [];
  loadedContent = false;

  orderInfo!: any;

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, private refundsService: RefundsService, private router: Router) { }

  ngOnInit() {
    if (this.data) {
      if (this.data?.id_transaction) {
        this.refundsService.getOrderByIdInvoice(this.data.id_transaction).subscribe((res: any) => {
          this.orderInfo = res.data;
          this.createEventArray();
        });
      }

    }
  }

  createEventArray() {
    this.bookingsOrder = [];

    this.orderInfo.cart?.cart_lines?.forEach(line => {
      let eventIndex = this.bookingsOrder.findIndex(eventSession => eventSession.event.id == line.event.id && eventSession.session.start_date == line.session.start_date);
      if (eventIndex == -1) {
        let bookings = [];
        line.bookings.forEach(booking => {
          bookings.push({ticket: line.ticket, booking: booking, price: +booking.price});
        });
        this.bookingsOrder.push(
          {
            event: line.event,
            session: line.session,
            bookings: bookings
          }
        );

      } else {
        line.bookings.forEach(booking => {
          this.bookingsOrder[eventIndex].bookings.push({ticket: line.ticket, booking: booking, price: +booking.price});
        });
      }
    });
    this.loadedContent = true;
  }

  goToDetail() {
    this.router.navigate(['/refunds/', this.orderInfo.id_invoicing]);
    this.dialog.closeAll();
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  refundOrder() {
    const dialogRef = this.dialog.open(DialogRefundConfirmComponent, {
      width: '650px',
      panelClass: 'rounded-dialog',
      data: { id: this.orderInfo.id_invoicing, work_time: localStorage.getItem('id_work_time') }
    })
  }
}
